import type { ElementType, ReactNode } from 'react';
import { cn } from '../lib/cn';

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon: ElementType;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-2xl border border-dashed border-white/[0.08] bg-white/[0.012] px-6 py-12 text-center',
        className,
      )}
    >
      <div className="mb-4 flex size-12 items-center justify-center rounded-2xl border border-white/[0.08] bg-white/[0.03]">
        <Icon className="size-5 text-zinc-500" strokeWidth={1.7} />
      </div>
      <p className="text-[15px] font-medium text-zinc-200">{title}</p>
      {description && <p className="mt-1.5 max-w-sm text-[13px] leading-relaxed text-zinc-500">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
